const Badge = {
  defaultProps: {
    variant: 'filled',
    size: 'xl',
    color: 'primary',
  },
  styles: {
    inner: {
      fontWeight: 400,
      textTransform: 'none',
    },
  },
};

export default Badge;
